export default __webpack_public_path__ + "static/media/d9a2dbee28723703870d5c53596919ff1600871513476.1fbefda2.webp";